import {
  Row,
  Col,
  Card,
  Select,
  Tag,
  Button,
  Typography,
  Statistic,
  Timeline,
  Drawer,
  Form,
  Input,
  Radio,
  DatePicker,
  Space,
  Divider,
  Progress,
  Avatar,
  Empty,
  Alert,
  InputNumber,
  Spin,
  message,
  Upload,
} from "antd";
import { useState, useMemo, useEffect, useRef } from "react";
import {
  APIProvider,
  Map,
  AdvancedMarker,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import Dragger from "antd/es/upload/Dragger";
import {
  FilePdfOutlined,
  EnvironmentOutlined,
  CarOutlined,
  ClockCircleOutlined,
  AimOutlined,
  CheckCircleOutlined,
  FileSearchOutlined,
  CalendarOutlined,
  UserOutlined,
  PushpinOutlined,
  HomeOutlined,
  CompassOutlined,
  InboxOutlined,
  DeleteOutlined,
  DollarOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import MotionHoc from "../../../utils/MotionHoc";
import Compressor from "compressorjs";
import axios from "axios";
import { HEADERS_UPIMAGE, POST_DELETE_IMAGE_NEW } from "../../API/apiUrls";

const { Title, Text } = Typography;
const { TextArea } = Input;

/* แนะนำย้ายไป .env: VITE_GOOGLE_MAPS_API_KEY / VITE_GOOGLE_MAPS_MAP_ID
   และจำกัด key ด้วย HTTP referrer ใน Google Cloud
   ⚠️ ต้องเปิด Geocoding API เพิ่มด้วย (สำหรับแปลง ต./อ./จ. -> พิกัด) */
const GOOGLE_MAPS_API_KEY = "AIzaSyAD6ze_VDeAzbJSQDBl4zr-B0vmwehgR8U";
/* ⚠️ ต้องเป็น "Map ID" จาก Google Cloud > Maps > Map Management
   (ค่าสั้น ๆ คนละตัวกับ API key) — ค่าด้านล่างยังผิดอยู่ ให้แก้เป็น Map ID จริง */
const GOOGLE_MAPS_MAP_ID = "690dcc2fdbbee56e927be075";

/* จุดเริ่มต้นการเดินทาง = สำนักงานขอนแก่น */
const ORIGIN = {
  name: "สำนักงานขอนแก่น",
  address: "อ.เมืองขอนแก่น จ.ขอนแก่น",
  lat: 16.4322,
  lng: 102.8236,
};

/* ------------------------------------------------------------------ */
/* สถานะการสืบ (ระดับแปลง) — หมุด/route ใช้สีตามสถานะ                     */
/* ------------------------------------------------------------------ */
const RESULT_META = {
  pending: { label: "รอลงพื้นที่", color: "#faad14", tag: "orange" },
  found: { label: "พบทรัพย์", color: "#52c41a", tag: "green" },
  notfound: { label: "ไม่พบทรัพย์", color: "#ff4d4f", tag: "red" },
};

/* ตัวเลือกสำหรับฟอร์มลงผลสืบ (ระดับทรัพย์) */
const ASSET_TYPE_OPTIONS = [
  { label: "น.ส.4 จ (โฉนด)", value: 1 },
  { label: "น.ส.3 ก.", value: 2 },
];
const LAND_DETAIL_OPTIONS = [
  { label: "ที่อยู่อาศัย", value: "ที่อยู่อาศัย" },
  { label: "ที่เกษตรกรรม", value: "ที่เกษตรกรรม" },
  { label: "ที่ว่างเปล่า", value: "ที่ว่างเปล่า" },
  { label: "ที่พาณิชยกรรม", value: "ที่พาณิชยกรรม" },
];
const MORTGAGE_OPTIONS = [
  { label: "ไม่ติดภาระ", value: 0 },
  { label: "ติดจำนอง", value: "จำนอง" },
  { label: "ติดขายฝาก", value: "ขายฝาก" },
];
const SEQUESTRATE_OPTIONS = [
  { label: "ไม่ติดอายัด", value: 0 },
  { label: "ติดอายัด", value: 1 },
];
const GARNISH_OPTIONS = [
  { label: "ไม่อายัดเงินได้", value: 0 },
  { label: "อายัดเงินได้", value: 1 },
];

const baht = {
  formatter: (v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
  parser: (v) => v.replace(/\$\s?|(,*)/g, ""),
};

// ทรัพย์เริ่มต้น 1 แปลง (prefill จาก stop)
const makeDefaultAsset = (stop) => ({
  assetPropotyType: stop?.typeLand ?? undefined,
  deed: stop?.numberLand ?? undefined,
  propertyDetail: undefined,
  rai: undefined,
  ngan: undefined,
  wa: undefined,
  latlon:
    stop?.lat != null && stop?.lng != null
      ? `${stop.lat}, ${stop.lng}`
      : undefined,
  mortgageStatus: 0,
  sequestrateStatus: 0,
  estimatedPrice: undefined,
  assetMemo: undefined,
});

/* ------------------------------------------------------------------ */
/* MOCK — รอบส่งสืบ (รู้แค่ ต./อ./จ. -> ใช้ geocode หาพิกัด)              */
/* lat/lng ที่ใส่ไว้เป็น "fallback" กรณี geocode ไม่ได้/ยังไม่เปิด API     */
/* ------------------------------------------------------------------ */
const MOCK_ROUNDS = [
  {
    invRoundId: 86,
    roundName: "รอบสืบสายหนองคาย",
    sendDate: "2026-06-23",
    investigatorName: "นายภาคิน สืบทรัพย์",
    zoneDesc: "ภาคอีสานตอนบน",
    stops: [
      {
        landId: 1334,
        contno: "2-0012446",
        ownerName: "หจก. ทีเอ ทรานสปอร์ต (2017)",
        garno: 0,
        numberLand: "84644",
        typeLand: 1,
        address: "ต.หาดคำ อ.เมืองหนองคาย จ.หนองคาย",
        lat: 17.91,
        lng: 102.76,
      },
      {
        landId: 1335,
        contno: "2-0012446",
        ownerName: "หจก. ทีเอ ทรานสปอร์ต (2017)",
        garno: 0,
        numberLand: "84927",
        typeLand: 1,
        address: "ต.ในเมือง อ.เมืองหนองคาย จ.หนองคาย",
        lat: 17.8782,
        lng: 102.7412,
      },
      {
        landId: 1501,
        contno: "2-0011500",
        ownerName: "นายสมศักดิ์ ทองแท้",
        garno: 0,
        numberLand: "20155",
        typeLand: 1,
        address: "ต.ท่าบ่อ อ.ท่าบ่อ จ.หนองคาย",
        lat: 17.85,
        lng: 102.586,
      },
      {
        landId: 1601,
        contno: "2-0011800",
        ownerName: "นางมาลี ศรีสุข",
        garno: 1,
        numberLand: "33871",
        typeLand: 2,
        address: "ต.จุมพล อ.โพนพิสัย จ.หนองคาย",
        lat: 18.026,
        lng: 103.079,
      },
      {
        landId: 1701,
        contno: "2-0012100",
        ownerName: "นายวีระ ใจกล้า",
        garno: 0,
        numberLand: "57420",
        typeLand: 1,
        address: "ต.พานพร้าว อ.ศรีเชียงใหม่ จ.หนองคาย",
        lat: 17.9,
        lng: 102.5,
      },
    ],
  },
  {
    invRoundId: 90,
    roundName: "รอบสืบสายอุดรธานี",
    sendDate: "2026-06-24",
    investigatorName: "นางสาวกมลชนก เร่งสืบ",
    zoneDesc: "ภาคอีสานตอนบน",
    stops: [
      {
        landId: 1336,
        contno: "2-0012446",
        ownerName: "หจก. ทีเอ ทรานสปอร์ต (2017)",
        garno: 0,
        numberLand: "11023",
        typeLand: 1,
        address: "ต.หมากแข้ง อ.เมืองอุดรธานี จ.อุดรธานี",
        lat: 17.4138,
        lng: 102.787,
      },
      {
        landId: 1810,
        contno: "2-0013000",
        ownerName: "นายธนกร พูนผล",
        garno: 0,
        numberLand: "88012",
        typeLand: 1,
        address: "ต.หนองบัว อ.เมืองอุดรธานี จ.อุดรธานี",
        lat: 17.43,
        lng: 102.81,
      },
      {
        landId: 1811,
        contno: "2-0013200",
        ownerName: "นางสุดา แก้วใส",
        garno: 2,
        numberLand: "90233",
        typeLand: 2,
        address: "ต.กุมภวาปี อ.กุมภวาปี จ.อุดรธานี",
        lat: 17.11,
        lng: 103.01,
      },
    ],
  },
];

const ownerType = (garno) =>
  garno === 0 ? "ผู้เช่าซื้อ" : garno ? `คนค้ำที่ ${garno}` : "-";
const typeLandLabel = (v) => (v === 1 ? "โฉนด" : v === 2 ? "นส.3" : (v ?? "-"));

const stopState = (result) => {
  if (!result) return "pending";
  return result.found === "found" ? "found" : "notfound";
};

/* ------------------------------------------------------------------ */
/* สร้างลิงก์ Google Maps Directions                                    */
/* ------------------------------------------------------------------ */
const buildRouteUrl = (origin, stops) => {
  if (!stops.length) return null;
  const o = `${origin.lat},${origin.lng}`;
  const params = new URLSearchParams({
    api: "1",
    origin: o,
    destination: o, // กลับจุดเริ่มต้น
    travelmode: "driving",
  });
  const wp = stops.map((s) => `${s.lat},${s.lng}`).join("|");
  params.set("waypoints", wp);
  return `https://www.google.com/maps/dir/?${params.toString()}`;
};

const buildSingleUrl = (origin, stop) => {
  const params = new URLSearchParams({
    api: "1",
    origin: `${origin.lat},${origin.lng}`,
    destination: `${stop.lat},${stop.lng}`,
    travelmode: "driving",
  });
  return `https://www.google.com/maps/dir/?${params.toString()}`;
};

/* ================================================================== */
/* Geocoder — แปลงที่อยู่ (ต./อ./จ.) เป็นพิกัด lat/lng                    */
/* ทำงานในบริบท Maps (มี google) + cache กัน geocode ซ้ำ + ทำตามลำดับ     */
/* ================================================================== */
function Geocoder({ addresses, onResolved }) {
  const geocodingLib = useMapsLibrary("geocoding");
  const cacheRef = useRef({}); // address -> {lat,lng} | null

  useEffect(() => {
    if (!geocodingLib || !addresses || addresses.length === 0) return;
    let cancelled = false;
    const geocoder = new geocodingLib.Geocoder();

    const run = async () => {
      const resolved = { ...cacheRef.current };
      let changed = false;

      for (const addr of addresses) {
        if (resolved[addr] !== undefined) continue; // มีใน cache แล้ว (รวมค่า null)
        try {
          const { results } = await geocoder.geocode({
            address: addr,
            componentRestrictions: { country: "TH" },
          });
          if (results && results[0]) {
            const loc = results[0].geometry.location;
            resolved[addr] = { lat: loc.lat(), lng: loc.lng() };
          } else {
            resolved[addr] = null;
          }
        } catch (err) {
          console.warn("geocode fail:", addr, err?.message || err);
          resolved[addr] = null;
        }
        changed = true;
      }

      cacheRef.current = resolved;
      if (!cancelled && changed) onResolved?.({ ...resolved });
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [geocodingLib, addresses, onResolved]);

  return null;
}

/* ================================================================== */
/* หมุดเลข (HTML/CSS) — ใช้กับ AdvancedMarker                           */
/* ================================================================== */
const NumberPin = ({ number, color, selected }) => (
  <div
    style={{
      width: selected ? 38 : 32,
      height: selected ? 38 : 32,
      borderRadius: "50%",
      background: color,
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      fontSize: selected ? 15 : 13,
      border: `${selected ? 4 : 2}px solid #fff`,
      boxShadow: "0 2px 6px rgba(0,0,0,0.35)",
      transform: "translateY(-50%)",
      cursor: "pointer",
    }}
  >
    {number}
  </div>
);

/* หมุดจุดเริ่มต้น (ขอนแก่น) */
const StartPin = () => (
  <div
    style={{
      background: "#1677ff",
      color: "#fff",
      padding: "4px 10px",
      borderRadius: 14,
      fontWeight: 700,
      fontSize: 12,
      whiteSpace: "nowrap",
      border: "2px solid #fff",
      boxShadow: "0 2px 6px rgba(0,0,0,0.35)",
      transform: "translateY(-50%)",
    }}
  >
    🚩 จุดเริ่มต้น
  </div>
);

/* ================================================================== */
/* RoutePolyline — DirectionsService + optimizeWaypoints                */
/* ================================================================== */
function RoutePolyline({ origin, stops, onRouteInfo, onOptimized }) {
  const map = useMap();
  const routesLib = useMapsLibrary("routes");
  const [poly, setPoly] = useState(null);

  useEffect(() => {
    if (!map || !window.google) return;
    const line = new window.google.maps.Polyline({
      map,
      strokeColor: "#1677ff",
      strokeWeight: 5,
      strokeOpacity: 0.9,
    });
    setPoly(line);
    return () => line.setMap(null);
  }, [map]);

  useEffect(() => {
    if (!routesLib || !poly) return;

    if (stops.length < 1) {
      poly.setPath([]);
      onRouteInfo?.({ distance: 0, duration: 0 });
      onOptimized?.(null);
      return;
    }

    const service = new routesLib.DirectionsService();
    service.route(
      {
        origin: { lat: origin.lat, lng: origin.lng },
        destination: { lat: origin.lat, lng: origin.lng }, // round trip
        waypoints: stops.map((s) => ({
          location: { lat: s.lat, lng: s.lng },
          stopover: true,
        })),
        optimizeWaypoints: true,
        travelMode: routesLib.TravelMode.DRIVING,
      },
      (res, status) => {
        if (status === "OK" && res) {
          poly.setPath(res.routes[0].overview_path);
          const legs = res.routes[0]?.legs || [];
          onRouteInfo?.({
            distance: legs.reduce((s, l) => s + (l.distance?.value || 0), 0),
            duration: legs.reduce((s, l) => s + (l.duration?.value || 0), 0),
          });
          onOptimized?.(res.routes[0].waypoint_order || null);
        } else {
          console.log("Directions status:", status, res);
          poly.setPath([
            { lat: origin.lat, lng: origin.lng },
            ...stops.map((s) => ({ lat: s.lat, lng: s.lng })),
            { lat: origin.lat, lng: origin.lng },
          ]);
          onRouteInfo?.(null);
          onOptimized?.(null);
        }
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routesLib, poly, origin, stops]);

  return null;
}

/* ================================================================== */
/* MapController — fit bounds (รวมจุดเริ่ม) + pan ไปยังหมุดที่เลือก       */
/* ================================================================== */
function MapController({ origin, stops, selectedId }) {
  const map = useMap();

  useEffect(() => {
    if (!map || !window.google || stops.length === 0) return;
    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend({ lat: origin.lat, lng: origin.lng });
    stops.forEach((s) => bounds.extend({ lat: s.lat, lng: s.lng }));
    map.fitBounds(bounds, 64);
  }, [map, stops, origin]);

  useEffect(() => {
    if (!map || selectedId == null) return;
    const s = stops.find((x) => x.landId === selectedId);
    if (s) {
      map.panTo({ lat: s.lat, lng: s.lng });
      map.setZoom(13);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedId]);

  return null;
}

/* ================================================================== */
/* RouteMap — vis.gl + Geocoder                                        */
/* ================================================================== */
function RouteMap({
  origin,
  stops,
  rawStops,
  addresses,
  onGeocoded,
  results,
  selectedId,
  onSelectStop,
  onRouteInfo,
  onOptimized,
}) {
  if (!GOOGLE_MAPS_API_KEY) {
    return (
      <Alert
        type="warning"
        showIcon
        message="ยังไม่ได้ตั้งค่า Google Maps API Key"
      />
    );
  }

  return (
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
      {/* แปลงที่อยู่เป็นพิกัด (ส่งกลับขึ้น Main) */}
      <Geocoder addresses={addresses} onResolved={onGeocoded} />

      <div style={{ height: 560, borderRadius: 12, overflow: "hidden" }}>
        <Map
          mapId={GOOGLE_MAPS_MAP_ID}
          defaultCenter={{ lat: origin.lat, lng: origin.lng }}
          defaultZoom={9}
          gestureHandling="greedy"
          streetViewControl={false}
          mapTypeControl={false}
        >
          <MapController
            origin={origin}
            stops={stops}
            selectedId={selectedId}
          />
          <RoutePolyline
            origin={origin}
            stops={rawStops}
            onRouteInfo={onRouteInfo}
            onOptimized={onOptimized}
          />

          {/* หมุดจุดเริ่มต้น */}
          <AdvancedMarker
            position={{ lat: origin.lat, lng: origin.lng }}
            zIndex={0}
          >
            <StartPin />
          </AdvancedMarker>

          {/* หมุดทรัพย์ตามลำดับ */}
          {stops.map((s, i) => {
            const state = stopState(results[s.landId]);
            return (
              <AdvancedMarker
                key={s._key}
                position={{ lat: s.lat, lng: s.lng }}
                zIndex={selectedId === s.landId ? 999 : i + 1}
                onClick={() => onSelectStop?.(s.landId)}
              >
                <NumberPin
                  number={i + 1}
                  color={RESULT_META[state].color}
                  selected={selectedId === s.landId}
                />
              </AdvancedMarker>
            );
          })}
        </Map>
      </div>
    </APIProvider>
  );
}

/* ================================================================== */
/* Main page                                                           */
/* ================================================================== */
const Main = () => {
  const [roundId, setRoundId] = useState(MOCK_ROUNDS[0].invRoundId);
  const [results, setResults] = useState({});
  const [selectedId, setSelectedId] = useState(null);
  const [editingStop, setEditingStop] = useState(null);
  const [routeInfo, setRouteInfo] = useState(null);
  const [waypointOrder, setWaypointOrder] = useState(null); // ลำดับที่ Google จัดให้
  const [coordsMap, setCoordsMap] = useState({}); // address -> {lat,lng} | null (จาก geocode)
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [allImg, setAllImg] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [loading, setLoading] = useState(false);

  const round = useMemo(
    () => MOCK_ROUNDS.find((r) => r.invRoundId === roundId),
    [roundId],
  );

  // ที่อยู่ทั้งหมดในรอบ (ไม่ซ้ำ) -> ส่งให้ Geocoder
  const addresses = useMemo(() => {
    const set = new Set((round?.stops || []).map((s) => s.address));
    return [...set];
  }, [round]);

  // stops ดิบ + ใส่พิกัดจาก geocode (ถ้ายังไม่ได้ ใช้ lat/lng เดิมเป็น fallback)
  const rawStops = useMemo(() => {
    const base = round?.stops || [];
    return base.map((s, idx) => {
      const geo = coordsMap[s.address];
      return {
        ...s,
        _key: `${s.landId}-${idx}`, // key ไม่ซ้ำ (กัน landId ซ้ำ)
        lat: geo?.lat ?? s.lat ?? null,
        lng: geo?.lng ?? s.lng ?? null,
      };
    });
  }, [round, coordsMap]);

  // เฉพาะจุดที่มีพิกัดแล้ว (ใช้วาด route/หมุด)
  const mappableStops = useMemo(
    () => rawStops.filter((s) => s.lat != null && s.lng != null),
    [rawStops],
  );

  // จัดลำดับตามเส้นทางจริงจาก Google (waypoint_order) — อิงจาก mappableStops
  const stops = useMemo(() => {
    if (!waypointOrder || waypointOrder.length !== mappableStops.length)
      return mappableStops;
    return waypointOrder.map((idx) => mappableStops[idx]);
  }, [mappableStops, waypointOrder]);

  // ยังหาพิกัดไม่ครบหรือไม่ (ใช้โชว์ loading)
  const geocoding = addresses.some((a) => coordsMap[a] === undefined);

  const stats = useMemo(() => {
    const totalPlots = stops.length;
    const contracts = new Set(stops.map((s) => s.contno)).size;
    const done = stops.filter((s) => results[s.landId]).length;
    return { totalPlots, contracts, done };
  }, [stops, results]);

  const progressPercent = stats.totalPlots
    ? Math.round((stats.done / stats.totalPlots) * 100)
    : 0;

  const openEditor = (stop) => {
    setEditingStop(stop);
    setSelectedId(stop.landId);
    const r = results[stop.landId];
    form.setFieldsValue({
      found: r?.found || "found",
      investigatedAt: r?.investigatedAt ? dayjs(r.investigatedAt) : dayjs(),
      garnishStatus: r?.garnishStatus ?? 0,
      garnishAmount: r?.garnishAmount,
      garnishSource: r?.garnishSource,
      note: r?.note,
      assets: r?.assets?.length ? r.assets : [makeDefaultAsset(stop)],
    });
  };

  const handleSave = async () => {
    try {
      const v = await form.validateFields();
      setResults((prev) => ({
        ...prev,
        [editingStop.landId]: {
          ...v,
          investigatedAt: v.investigatedAt?.toISOString(),
        },
      }));
      const n = v.found === "found" ? v.assets?.length || 0 : 0;
      message.success(
        v.found === "found"
          ? `บันทึกผลสืบ ${editingStop.ownerName} — พบทรัพย์ ${n} แปลง`
          : `บันทึกผลสืบ ${editingStop.ownerName} — ไม่พบทรัพย์`,
      );
      setEditingStop(null);
    } catch {
      /* validation error */
    }
  };

  const compressImage = async (file, types, index) => {
    return new Promise((resolve) => {
      let quality;
      if (file.size >= 2500000) quality = 0.1;
      else if (file.size >= 2000000) quality = 0.15;
      else if (file.size >= 1500000) quality = 0.2;
      else if (file.size >= 1000000) quality = 0.3;
      else quality = 0.5;

      new Compressor(file, {
        quality: quality,
        success: (result) => {
          const fileOptions = {
            type: result.type,
            lastModified: Date.now(),
          };
          const compressedFileAsFile = new File(
            [result],
            file.name,
            fileOptions,
          );

          const image = {
            imageCompressedFile: compressedFileAsFile,
            type: types,
            originalIndex: index,
          };

          setAllImg((prev) => [...prev, image]);
          setLoading(false);
          resolve(true);
        },
        error: (err) => {
          console.error("Compressor error:", err);
          message.error(`ไม่สามารถบีบอัดไฟล์ "${file.name}" ได้`);
          setLoading(false);
          resolve(true);
        },
      });
    });
  };

  // ลบรูป (รับ array)
  const handleDeleteIMG = async (images) => {
    if (!images || images.length === 0) return;

    setLoading(true);
    try {
      const res = await axios.delete(POST_DELETE_IMAGE_NEW, {
        data: images,
        headers: HEADERS_UPIMAGE,
      });

      if (res.status === 200) {
        const selectedPaths = new Set(images.map((img) => img.path));
        message.success("ลบรูปสำเร็จ");
      }
    } catch (err) {
      message.error("เกิดข้อผิดพลาด ลบรูปไม่สำเร็จ");
      console.error("err", err);
    } finally {
      setLoading(false);
    }
  };

  // ลบรูปเดียว - ส่งเป็น array
  const handleDeleteSingleImage = async (image) => {
    await handleDeleteIMG([image]);
  };

  // Preview รูป
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
      let pdfUrl = file.url;
      if (!pdfUrl && file.originFileObj) {
        pdfUrl = URL.createObjectURL(file.originFileObj);
      }
      window.open(pdfUrl, "_blank");
      return;
    }

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  // Handle change file list
  const handleChangeIMG = ({ fileList: newFileList, file }) => {
    const updatedFileList = newFileList.map((f) => f);

    setFileList(updatedFileList);

    if (file.status === "removed") {
      setAllImg((prevAllImg) => {
        return prevAllImg.filter((img) => img.originalIndex !== file.uid);
      });
    }

    if (
      file.status === "done" ||
      file.status === "removed" ||
      file.status === "error"
    ) {
      setLoading(false);
    }
  };

  // Before upload
  const beforeUpts = async (file, ty) => {
    const isPdf =
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf");

    if (isPdf) {
      const image = {
        imageCompressedFile: file,
        type: ty,
        originalIndex: file.uid,
      };
      setAllImg((prev) => [...prev, image]);
      return false;
    }

    if (file.size > 5000000) {
      message.warning(`ไฟล์ "${file.name}" เกิน 5MB`);
      return Upload.LIST_IGNORE;
    }

    try {
      setLoading(true);
      await compressImage(file, ty, file.uid);
      return false;
    } catch (error) {
      console.error("File processing error:", error);
      message.error("File processing failed.");
      return Upload.LIST_IGNORE;
    }
  };

  // Upload Props
  const uploadProps = {
    name: "file",
    multiple: true,
    accept: "image/*,.pdf",
    listType: "picture",
    fileList: fileList,
    onPreview: handlePreview,
    onChange: handleChangeIMG,
    beforeUpload: (file) => beforeUpts(file, 3),
    iconRender: (file) => {
      if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
        return (
          <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f" }} />
        );
      }
      return null;
    },
  };

  return (
    <div>
      {/* ====== Header การ์ดรอบ ====== */}
      <Card
        style={{
          marginBottom: 12,
          borderRadius: 14,
          border: "none",
          background: "linear-gradient(135deg, #1677ff 0%, #0958d9 100%)",
        }}
        styles={{ body: { padding: 20 } }}
      >
        <Row align="middle" gutter={[16, 16]}>
          <Col xs={24} md={10}>
            <Space align="center" size={14}>
              <Avatar
                size={52}
                style={{ background: "rgba(255,255,255,0.2)" }}
                icon={<CarOutlined style={{ fontSize: 24 }} />}
              />
              <div>
                <Select
                  variant="borderless"
                  value={roundId}
                  onChange={(v) => {
                    setRoundId(v);
                    setSelectedId(null);
                    setRouteInfo(null);
                    setWaypointOrder(null);
                  }}
                  style={{ minWidth: 240 }}
                  options={MOCK_ROUNDS.map((r) => ({
                    value: r.invRoundId,
                    label: r.roundName,
                  }))}
                  labelRender={({ label }) => (
                    <Title level={4} style={{ color: "#fff", margin: 0 }}>
                      {label}
                    </Title>
                  )}
                />
                <Space
                  size={16}
                  wrap
                  style={{ color: "rgba(255,255,255,0.9)" }}
                >
                  <span>
                    <CalendarOutlined />{" "}
                    {dayjs(round.sendDate).add(543, "year").format("D MMM YY")}
                  </span>
                  <span>
                    <UserOutlined /> {round.investigatorName}
                  </span>
                  <span>
                    <HomeOutlined /> เริ่มจาก {ORIGIN.name}
                  </span>
                </Space>
              </div>
            </Space>
          </Col>

          <Col xs={24} md={14}>
            <Row gutter={8}>
              {[
                { title: "จำนวนแปลง", value: stats.totalPlots, suffix: "แปลง" },
                {
                  title: "จำนวนสัญญา",
                  value: stats.contracts,
                  suffix: "สัญญา",
                },
                {
                  title: "ระยะทางไป-กลับ (ประมาณ)",
                  value: routeInfo
                    ? (routeInfo.distance / 1000).toFixed(1)
                    : "-",
                  suffix: "กม.",
                },
              ].map((s, i) => (
                <Col xs={12} sm={8} key={i}>
                  <div
                    style={{
                      background: "rgba(255,255,255,0.15)",
                      borderRadius: 10,
                      padding: "10px 12px",
                      textAlign: "center",
                    }}
                  >
                    <Statistic
                      title={
                        <span style={{ color: "rgba(255,255,255,0.85)" }}>
                          {s.title}
                        </span>
                      }
                      value={s.value}
                      suffix={
                        <span style={{ color: "#fff", fontSize: 13 }}>
                          {s.suffix}
                        </span>
                      }
                      valueStyle={{
                        color: "#fff",
                        fontSize: 22,
                        fontWeight: 700,
                      }}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>

        <Divider
          style={{
            borderColor: "rgba(255,255,255,0.2)",
            margin: "16px 0 10px",
          }}
        />
        <Progress
          percent={progressPercent}
          strokeColor="#52c41a"
          trailColor="rgba(255,255,255,0.25)"
          format={(p) => (
            <span style={{ color: "#fff" }}>
              สืบแล้ว {stats.done}/{stats.totalPlots} ({p}%)
            </span>
          )}
        />
      </Card>

      <Row gutter={[12, 12]}>
        {/* ====== ซ้าย: แผนที่ ====== */}
        <Col xs={24} lg={14}>
          <Card
            title={
              <Space>
                <AimOutlined style={{ color: "#1677ff" }} />
                เส้นทางการลงสืบ
              </Space>
            }
            extra={
              <Space size={12}>
                {Object.entries(RESULT_META).map(([k, m]) => (
                  <Space size={4} key={k}>
                    <span
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        background: m.color,
                        display: "inline-block",
                      }}
                    />
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      {m.label}
                    </Text>
                  </Space>
                ))}
              </Space>
            }
            style={{ borderRadius: 14, position: "sticky", top: 12 }}
          >
            {geocoding && (
              <Alert
                type="info"
                showIcon
                icon={<Spin size="small" />}
                message="กำลังค้นหาพิกัดจากที่อยู่ (ตำบล/อำเภอ/จังหวัด)..."
                style={{ marginBottom: 12 }}
              />
            )}
            <Button
              type="primary"
              icon={<CompassOutlined />}
              block
              disabled={stops.length === 0}
              href={buildRouteUrl(ORIGIN, stops) || undefined}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginBottom: 12, borderRadius: 8 }}
            >
              นำทางทั้งเส้นทางใน Google Maps ({stops.length} จุด)
            </Button>
            <RouteMap
              origin={ORIGIN}
              stops={stops}
              rawStops={mappableStops}
              addresses={addresses}
              onGeocoded={(m) => setCoordsMap((prev) => ({ ...prev, ...m }))}
              results={results}
              selectedId={selectedId}
              onSelectStop={setSelectedId}
              onRouteInfo={setRouteInfo}
              onOptimized={setWaypointOrder}
            />
          </Card>
        </Col>

        {/* ====== ขวา: ลำดับเส้นทาง + ลงผลรายแปลง ====== */}
        <Col xs={24} lg={10}>
          <Card
            title={
              <Space>
                <PushpinOutlined style={{ color: "#1677ff" }} />
                จุดสืบตามลำดับ ({stops.length})
              </Space>
            }
            style={{ borderRadius: 14 }}
            styles={{ body: { paddingTop: 12 } }}
          >
            {stops.length === 0 ? (
              <Empty
                description={
                  geocoding ? "กำลังค้นหาพิกัด..." : "ไม่มีทรัพย์ในรอบนี้"
                }
              />
            ) : (
              <Timeline
                items={[
                  {
                    color: "#1677ff",
                    dot: (
                      <span
                        style={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          background: "#1677ff",
                          color: "#fff",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 12,
                        }}
                      >
                        <HomeOutlined />
                      </span>
                    ),
                    children: (
                      <div style={{ paddingBottom: 4 }}>
                        <Text strong>{ORIGIN.name}</Text>
                        <div style={{ color: "#666", fontSize: 13 }}>
                          <EnvironmentOutlined /> {ORIGIN.address}
                        </div>
                        <Tag color="blue" style={{ marginTop: 4 }}>
                          จุดเริ่มต้น
                        </Tag>
                      </div>
                    ),
                  },
                  ...stops.map((s, i) => {
                    const state = stopState(results[s.landId]);
                    const meta = RESULT_META[state];
                    const isSelected = selectedId === s.landId;
                    return {
                      color: meta.color,
                      dot: (
                        <span
                          style={{
                            width: 24,
                            height: 24,
                            borderRadius: "50%",
                            background: meta.color,
                            color: "#fff",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 12,
                            fontWeight: 700,
                          }}
                        >
                          {i + 1}
                        </span>
                      ),
                      children: (
                        <Card
                          size="small"
                          hoverable
                          onClick={() => setSelectedId(s.landId)}
                          style={{
                            borderRadius: 10,
                            marginBottom: 4,
                            borderColor: isSelected ? "#1677ff" : undefined,
                            boxShadow: isSelected
                              ? "0 0 0 2px rgba(22,119,255,0.15)"
                              : undefined,
                          }}
                          styles={{ body: { padding: 12 } }}
                        >
                          <Row justify="space-between" align="top">
                            <Col flex="auto">
                              <Text strong>{s.ownerName}</Text>
                              <div>
                                <Tag style={{ marginTop: 4 }}>{s.contno}</Tag>
                                <Tag color="default">{ownerType(s.garno)}</Tag>
                              </div>
                            </Col>
                            <Col>
                              <Tag color={meta.tag}>{meta.label}</Tag>
                            </Col>
                          </Row>

                          <div style={{ margin: "8px 0", color: "#666" }}>
                            <EnvironmentOutlined /> {s.address}
                          </div>

                          <Space size={8} wrap>
                            <Tag color="blue">
                              {typeLandLabel(s.typeLand)} เลขที่ {s.numberLand}
                            </Tag>
                            {results[s.landId]?.investigatedAt && (
                              <Tag icon={<ClockCircleOutlined />}>
                                {dayjs(results[s.landId].investigatedAt).format(
                                  "D MMM HH:mm",
                                )}
                              </Tag>
                            )}
                          </Space>

                          <Divider style={{ margin: "10px 0" }} />
                          <Space.Compact block>
                            <Button
                              type={results[s.landId] ? "default" : "primary"}
                              size="small"
                              style={{ flex: 1 }}
                              icon={
                                results[s.landId] ? (
                                  <CheckCircleOutlined />
                                ) : (
                                  <FileSearchOutlined />
                                )
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                openEditor(s);
                              }}
                            >
                              {results[s.landId] ? "แก้ไขผลสืบ" : "บันทึกผลสืบ"}
                            </Button>
                            <Button
                              size="small"
                              icon={<CompassOutlined />}
                              href={buildSingleUrl(ORIGIN, s)}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              นำทาง
                            </Button>
                          </Space.Compact>
                        </Card>
                      ),
                    };
                  }),
                ]}
              />
            )}
          </Card>
        </Col>
      </Row>

      {/* ====== Drawer ลงผลการสืบ (รายบุคคล + หลายทรัพย์) ====== */}
      <Drawer
        title={
          editingStop ? (
            <Space direction="vertical" size={0}>
              <Text strong>บันทึกผลการสืบ</Text>
              <Text type="secondary" style={{ fontSize: 13 }}>
                {editingStop.ownerName} · {editingStop.contno} ·{" "}
                {ownerType(editingStop.garno)}
              </Text>
            </Space>
          ) : (
            "บันทึกผลการสืบ"
          )
        }
        width={560}
        open={!!editingStop}
        onClose={() => setEditingStop(null)}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button
              onClick={() => setEditingStop(null)}
              style={{ color: "#cf1322", marginRight: 12 }}
            >
              ปิด
            </Button>
            <Button type="primary" onClick={handleSave}>
              บันทึก
            </Button>
          </div>
        }
      >
        {editingStop && (
          <Form form={form} layout="vertical">
            <Form.Item
              name="found"
              label="ผลการสืบ"
              rules={[{ required: true, message: "กรุณาเลือกผลการสืบ" }]}
            >
              <Radio.Group buttonStyle="solid">
                <Radio.Button value="found">พบทรัพย์</Radio.Button>
                <Radio.Button value="notfound">ไม่พบทรัพย์</Radio.Button>
              </Radio.Group>
            </Form.Item>

            <Form.Item name="investigatedAt" label="วัน-เวลาที่สืบ">
              <DatePicker
                showTime
                format="D MMM YYYY HH:mm"
                style={{ width: "100%" }}
              />
            </Form.Item>

            {/* อายัดเงินได้ (ระดับบุคคล) */}
            <Divider orientation="left" style={{ margin: "8px 0 12px" }}>
              <Space size={6}>
                <DollarOutlined style={{ color: "#1677ff" }} />
                อายัดเงินได้
              </Space>
            </Divider>
            <Form.Item name="garnishStatus" initialValue={0}>
              <Radio.Group
                optionType="button"
                buttonStyle="solid"
                options={GARNISH_OPTIONS}
              />
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(p, c) => p.garnishStatus !== c.garnishStatus}
            >
              {({ getFieldValue }) =>
                getFieldValue("garnishStatus") === 1 ? (
                  <Row gutter={8}>
                    <Col span={12}>
                      <Form.Item
                        name="garnishAmount"
                        label="ยอดอายัด/เดือน"
                        rules={[{ required: true, message: "ระบุยอด" }]}
                      >
                        <InputNumber
                          {...baht}
                          suffix="บาท"
                          placeholder="0"
                          style={{ width: "100%" }}
                          size="large"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="garnishSource"
                        label="แหล่งเงินได้ / นายจ้าง"
                        rules={[
                          { required: true, message: "ระบุแหล่งเงินได้" },
                        ]}
                      >
                        <Input placeholder="เช่น บริษัท / หน่วยงาน" />
                      </Form.Item>
                    </Col>
                  </Row>
                ) : null
              }
            </Form.Item>

            {/* รายการทรัพย์ที่พบ — แสดงเมื่อ "พบทรัพย์" */}
            <Form.Item noStyle shouldUpdate={(p, c) => p.found !== c.found}>
              {({ getFieldValue }) =>
                getFieldValue("found") === "found" ? (
                  <>
                    <Divider
                      orientation="left"
                      style={{ margin: "8px 0 12px" }}
                    >
                      <Space size={6}>
                        <PushpinOutlined style={{ color: "#1677ff" }} />
                        รายการทรัพย์ที่พบ
                      </Space>
                    </Divider>

                    <Form.List name="assets">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name }, idx) => (
                            <Card
                              key={key}
                              size="small"
                              title={`ทรัพย์ที่ ${idx + 1}`}
                              extra={
                                fields.length > 1 ? (
                                  <Button
                                    type="text"
                                    danger
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    onClick={() => remove(name)}
                                  >
                                    ลบ
                                  </Button>
                                ) : null
                              }
                              style={{
                                marginBottom: 12,
                                borderRadius: 10,
                                background: "#fafafa",
                              }}
                            >
                              <Row gutter={8}>
                                <Col span={12}>
                                  <Form.Item
                                    name={[name, "assetPropotyType"]}
                                    label="ประเภททรัพย์"
                                    rules={[
                                      {
                                        required: true,
                                        message: "เลือกประเภท",
                                      },
                                    ]}
                                  >
                                    <Select
                                      placeholder="ประเภททรัพย์"
                                      options={ASSET_TYPE_OPTIONS}
                                      size="large"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={12}>
                                  <Form.Item
                                    name={[name, "deed"]}
                                    label="เลขโฉนด/เลขที่ดิน"
                                    rules={[
                                      {
                                        required: true,
                                        message: "ระบุเลขโฉนด",
                                      },
                                    ]}
                                  >
                                    <Input placeholder="เลขโฉนด" />
                                  </Form.Item>
                                </Col>
                              </Row>

                              <Form.Item
                                name={[name, "propertyDetail"]}
                                label="ลักษณะที่ดิน"
                              >
                                <Select
                                  placeholder="เลือกลักษณะที่ดิน"
                                  options={LAND_DETAIL_OPTIONS}
                                  allowClear
                                />
                              </Form.Item>

                              <Row gutter={8}>
                                <Col span={8}>
                                  <Form.Item name={[name, "rai"]} label="ไร่">
                                    <InputNumber
                                      min={0}
                                      style={{ width: "100%" }}
                                      placeholder="0"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item name={[name, "ngan"]} label="งาน">
                                    <InputNumber
                                      min={0}
                                      max={3}
                                      style={{ width: "100%" }}
                                      placeholder="0"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item name={[name, "wa"]} label="ตร.วา">
                                    <InputNumber
                                      min={0}
                                      max={99.99}
                                      step={0.01}
                                      style={{ width: "100%" }}
                                      placeholder="0.00"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>

                              <Form.Item
                                name={[name, "mapSheet"]}
                                label="เลขระวาง"
                              >
                                <Input placeholder="เช่น 5136 IV 6632" />
                              </Form.Item>

                              <Form.Item
                                name={[name, "latlon"]}
                                label="พิกัด (lat, lng)"
                              >
                                <Input placeholder="เช่น 17.91, 102.76" />
                              </Form.Item>

                              <Form.Item
                                name={[name, "mortgageStatus"]}
                                label="ติดภาระจำนอง/ขายฝาก"
                                initialValue={0}
                              >
                                <Radio.Group
                                  options={MORTGAGE_OPTIONS}
                                  optionType="button"
                                  buttonStyle="solid"
                                  size="small"
                                />
                              </Form.Item>
                              <Form.Item
                                noStyle
                                shouldUpdate={(p, c) =>
                                  p.assets?.[name]?.mortgageStatus !==
                                  c.assets?.[name]?.mortgageStatus
                                }
                              >
                                {({ getFieldValue }) =>
                                  getFieldValue([
                                    "assets",
                                    name,
                                    "mortgageStatus",
                                  ]) ? (
                                    <Row gutter={8}>
                                      <Col span={12}>
                                        <Form.Item
                                          name={[name, "mortgagee"]}
                                          label="เจ้าหนี้จำนอง/ขายฝาก"
                                        >
                                          <Input />
                                        </Form.Item>
                                      </Col>
                                      <Col span={12}>
                                        <Form.Item
                                          name={[name, "mortgageBalance"]}
                                          label="ยอดหนี้"
                                        >
                                          <InputNumber
                                            {...baht}
                                            suffix="บาท"
                                            placeholder="0"
                                            style={{ width: "100%" }}
                                            size="large"
                                          />
                                        </Form.Item>
                                      </Col>
                                    </Row>
                                  ) : null
                                }
                              </Form.Item>

                              <Form.Item
                                name={[name, "sequestrateStatus"]}
                                label="ติดอายัด"
                                initialValue={0}
                              >
                                <Radio.Group
                                  options={SEQUESTRATE_OPTIONS}
                                  optionType="button"
                                  buttonStyle="solid"
                                  size="small"
                                />
                              </Form.Item>
                              <Form.Item
                                noStyle
                                shouldUpdate={(p, c) =>
                                  p.assets?.[name]?.sequestrateStatus !==
                                  c.assets?.[name]?.sequestrateStatus
                                }
                              >
                                {({ getFieldValue }) =>
                                  getFieldValue([
                                    "assets",
                                    name,
                                    "sequestrateStatus",
                                  ]) === 1 ? (
                                    <Row gutter={8}>
                                      <Col span={12}>
                                        <Form.Item
                                          name={[name, "judgmentCreditor"]}
                                          label="เจ้าหนี้คำพิพากษา"
                                        >
                                          <Input />
                                        </Form.Item>
                                      </Col>
                                      <Col span={12}>
                                        <Form.Item
                                          name={[name, "redCaseNumber"]}
                                          label="เลขคดีแดง"
                                        >
                                          <Input />
                                        </Form.Item>
                                      </Col>
                                    </Row>
                                  ) : null
                                }
                              </Form.Item>

                              <Form.Item
                                name={[name, "assetImg"]}
                                label="รูปทรัพย์"
                              >
                                <Dragger
                                  {...uploadProps}
                                  style={{ width: "100%", minHeight: 200 }}
                                >
                                  <p className="ant-upload-drag-icon">
                                    <InboxOutlined
                                      style={{ color: "blue", fontSize: 48 }}
                                    />
                                  </p>
                                  <p
                                    className="ant-upload-text"
                                    style={{ fontSize: 16 }}
                                  >
                                    คลิกหรือลากไฟล์มาวางที่นี่
                                  </p>
                                  <p
                                    className="ant-upload-hint"
                                    style={{ fontSize: 12 }}
                                  >
                                    รองรับการอัปโหลดหลายไฟล์พร้อมกัน
                                  </p>
                                </Dragger>
                              </Form.Item>
                              <Form.Item
                                name={[name, "assetImgMaps"]}
                                label="รูปแผนที่"
                              >
                                <Dragger
                                  {...uploadProps}
                                  style={{ width: "100%", minHeight: 200 }}
                                >
                                  <p className="ant-upload-drag-icon">
                                    <InboxOutlined
                                      style={{ color: "blue", fontSize: 48 }}
                                    />
                                  </p>
                                  <p
                                    className="ant-upload-text"
                                    style={{ fontSize: 16 }}
                                  >
                                    คลิกหรือลากไฟล์มาวางที่นี่
                                  </p>
                                  <p
                                    className="ant-upload-hint"
                                    style={{ fontSize: 12 }}
                                  >
                                    รองรับการอัปโหลดหลายไฟล์พร้อมกัน
                                  </p>
                                </Dragger>
                              </Form.Item>
                            </Card>
                          ))}

                          {/* <Button
                            type="dashed"
                            block
                            icon={<PlusOutlined />}
                            onClick={() => add(makeDefaultAsset(null))}
                            style={{ marginBottom: 16 }}
                          >
                            เพิ่มทรัพย์
                          </Button> */}
                        </>
                      )}
                    </Form.List>
                  </>
                ) : null
              }
            </Form.Item>

            <Form.Item name="img" label="เอกสารกรมที่ดิน">
              <Dragger
                {...uploadProps}
                style={{ width: "100%", minHeight: 200 }}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined style={{ color: "blue", fontSize: 48 }} />
                </p>
                <p className="ant-upload-text" style={{ fontSize: 16 }}>
                  คลิกหรือลากไฟล์มาวางที่นี่
                </p>
                <p className="ant-upload-hint" style={{ fontSize: 12 }}>
                  รองรับการอัปโหลดหลายไฟล์พร้อมกัน
                </p>
              </Dragger>
            </Form.Item>

            <Form.Item name="note" label="หมายเหตุรวม">
              <TextArea rows={3} placeholder="บันทึกภาพรวมการลงพื้นที่..." />
            </Form.Item>
          </Form>
        )}
      </Drawer>
    </div>
  );
};

const MainInvestigationRoute = MotionHoc(Main);
export default MainInvestigationRoute;
